import { useState as o, useRef as u, useEffect as c } from "react";
const m = () => {
  const [n, i] = o({
    width: 0,
    height: 0
  }), e = u(null);
  return c(() => {
    const t = () => {
      if (e.current) {
        const {
          width: r,
          height: s
        } = e.current.getBoundingClientRect();
        i({
          width: r,
          height: s
        });
      }
    };
    return t(), window.addEventListener("resize", t), () => {
      window.removeEventListener("resize", t);
    };
  }, [e.current]), [e, n];
};
export {
  m as useDimension
};
